import React from "react";
import { PAGES } from "@chaos/website-frontend";

const { SearchPage } = PAGES;

export default SearchPage;
